import { render, staticRenderFns } from "./CamerataActivity.vue?vue&type=template&id=d8eae130"
import script from "./CamerataActivity.vue?vue&type=script&lang=js"
export * from "./CamerataActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports